import * as Yup from 'yup';
import { l10nEnService } from '@uplift/services';
import { isValidEmail } from '@uplift/validations';
import { ForgotPasswordFormType } from '../reset-password-form.component';
import { useMemo } from 'react';

export const useForgotPasswordValidationSchema = (l10n: typeof l10nEnService): Yup.ObjectSchema<ForgotPasswordFormType> => {
  return useMemo(() => {
    return Yup.object().shape({
      email: Yup.string()
        .email(l10n.validations.invalidEmail)
        .test('ascii-email', l10n.validations.validEmailOnly, isValidEmail)
        .required(l10n.validations.loginForm.emailBlank),
    });
  }, [ l10n.validations.invalidEmail, l10n.validations.validEmailOnly, l10n.validations.loginForm.emailBlank ]);
};
